import { IssueTaskCategory, IssueTaskDoc, IssueTaskStatus, issueTaskCategoryMap } from '@gooduncles/gu-app-schema';
import { Checkbox } from 'antd';
import dayjs from 'dayjs';
import { FC, useEffect, useState } from 'react';
import { map } from 'rxjs';

import { formatDate } from 'src/utils/date-util';
import { observeIssueTasks } from 'src/utils/firebase/firebase-short-cut';

import DatePickerWithArrows from 'src/components/Common/DatePickerWithArrows/DatePickerWithArrows';
import PrintWindow from 'src/components/PrintWindow/PrintWindow';

import classes from './IssueTaskPrint.module.scss';

/** 배송/회수 카테고리만 필터링 */
const PRINT_CATEGORIES: IssueTaskCategory[] = [IssueTaskCategory.DELIVERY, IssueTaskCategory.PICK_UP];

/** 상태 필터 옵션 */
const STATUS_OPTIONS = [
  { label: '입력', value: 'pending' },
  { label: '완료', value: 'completed' },
];

/** 상태 필터 값에 해당하는 IssueTaskStatus 매핑 */
const STATUS_FILTER_MAP: Record<string, IssueTaskStatus[]> = {
  pending: [IssueTaskStatus.PENDING, IssueTaskStatus.OPEN, IssueTaskStatus.IN_PROGRESS],
  completed: [IssueTaskStatus.COMPLETED],
};

const IssueTaskPrint: FC = () => {
  const [rowData, setRowData] = useState<IssueTaskDoc[]>([]);
  const [date, setDate] = useState<dayjs.Dayjs | null>(dayjs());
  const [selectedStatus, setSelectedStatus] = useState(['pending']);

  const onSelectedStatusChange = (checkedValues: string[]) => {
    setSelectedStatus(checkedValues);
  };

  useEffect(() => {
    if (date) {
      const targetDate = formatDate(date.toDate(), 'yyyy-MM-dd');
      const subscription = observeIssueTasks([['targetDate', '==', targetDate]])
        .pipe(
          map((docs) =>
            docs
              .filter((task) => PRINT_CATEGORIES.includes(task.category))
              .filter((task) => {
                const allowedStatuses = selectedStatus.flatMap((s) => STATUS_FILTER_MAP[s] ?? []);
                return allowedStatuses.includes(task.status);
              })
              .sort((a, b) => a.storeName.localeCompare(b.storeName))
          )
        )
        .subscribe(setRowData);
      return () => {
        subscription.unsubscribe();
      };
    }
  }, [date, selectedStatus]);

  return (
    <div className='height100 flexColumn'>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <DatePickerWithArrows date={date} setDate={setDate} />
        <Checkbox.Group options={STATUS_OPTIONS} value={selectedStatus} onChange={onSelectedStatusChange} />
      </div>
      <PrintWindow>
        <div className={classes.issueTaskPrintContainer}>
          <div className={`${classes.gridRow} ${classes.gridHeader}`}>
            <div>일자(예정일)</div>
            <div>구분</div>
            <div>매장</div>
            <div>특이사항</div>
            <div>고객노출</div>
          </div>
          {rowData.map((row) => (
            <div key={row._id} className={classes.gridRow}>
              <div>{row.targetDate ? formatDate(new Date(row.targetDate), 'yyyy. M. d') : '-'}</div>
              <div>{issueTaskCategoryMap[row.category]}</div>
              <div>{row.storeName ?? '-'}</div>
              <div className={classes.memo}>{row.privateNote}</div>
              <div>{row.publicNote}</div>
            </div>
          ))}
        </div>
      </PrintWindow>
    </div>
  );
};

export default IssueTaskPrint;
